import * as AuthHelper from './APIHelper';

export const RunReportQuery = (payload) =>
    AuthHelper.postResponse('/report/query', payload);

export const GetReportTemplates = () =>
    AuthHelper.getResponse('/report-template');

export const PostReportTemplate = (payload) =>
    AuthHelper.postResponse('/report-template', payload);

export const PutReportTemplate = (id, payload) =>
    AuthHelper.putResponse(`/report-template/${id}`, payload);

export const DeleteReportTemplate = (id) =>
    AuthHelper.deleteResponse(`/report-template/${id}`);
